import { EMOTES } from "@/lib/emotes";
import { Constants } from "@nextgammon/shared";
import { useEffect, useRef, useState } from "react";
import "../styles/emotes.css";

interface EmoteSelectorProps {
  onSend: (emoteId: Constants.EmoteId) => void;
  disabled?: boolean;
}

export function EmoteSelector({ onSend, disabled }: EmoteSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [cooldown, setCooldown] = useState(false);
  const cooldownTimerRef = useRef<NodeJS.Timeout>();

  const handleOpen = () => {
    if (cooldown || disabled) return;
    setIsOpen(true);
  };

  const handleSend = (emoteId: Constants.EmoteId) => {
    if (cooldown) return;

    // Send emote
    onSend(emoteId);

    // Close panel
    setIsOpen(false);

    // Start cooldown
    setCooldown(true);
    cooldownTimerRef.current = setTimeout(() => {
      setCooldown(false);
    }, Constants.EMOTE_COOLDOWN_MS);
  };

  useEffect(() => {
    return () => {
      if (cooldownTimerRef.current) {
        clearTimeout(cooldownTimerRef.current);
      }
    };
  }, []);

  return (
    <div className="emote-controls">
      {/* Emote picker button */}
      <button
        onClick={handleOpen}
        disabled={cooldown || disabled}
        className={`emote-trigger-button ${cooldown ? "cooldown" : ""}`}
        aria-label="Send emote"
      >
        😊
      </button>

      {/* Right-side panel */}
      {isOpen && (
        <>
          <div className="emote-panel-backdrop" onClick={() => setIsOpen(false)} />
          <div className={`emote-side-panel ${isOpen ? "open" : ""}`}>
            <div className="emote-grid">
              {EMOTES.map((emote) => (
                <button
                  key={emote.id}
                  onClick={() => handleSend(emote.id)}
                  className="emote-option"
                  title={emote.id}
                >
                  <img src={emote.img} alt={emote.id} />
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
